<template>
  <v-snackbar
    v-model="showSnackbar"
    :timeout="snackbarTimeout"
    :color="snackbarColor"
    top
    right
  >
    {{ snackbarText }}
  </v-snackbar>
</template>
<script>
import sharedComputed from './computed'

export default {
  name: 'Snackbar',

  computed: {
    ...sharedComputed
  }
}
</script>
